import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const baseUrl = import.meta.env.BASE_URL || '/';

class LocalesBackend {
    static type = 'backend';

    init(_services, backendOptions) {
        this.options = backendOptions || {};
    }

    read(language, _namespace, callback) {
        const url = `${baseUrl}locales/${language}.json`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to load locale');
                }
                return response.json();
            })
            .then((data) => callback(null, data))
            .catch((error) => callback(error, false));
    }
}

i18n.use(LocalesBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: `${baseUrl}locales/{{lng}}.json`,
        },
        supportedLngs: ['en', 'pl'],
        nonExplicitSupportedLngs: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        detection: {
            order: [
                'path',
                'cookie',
                'localStorage',
                'sessionStorage',
                'navigator',
                'htmlTag',
                'subdomain',
            ],
            caches: ['localStorage', 'cookie'],
        },
    });

export default i18n;
